import { deviceManager } from '../../device/device_manager'
import { dataProfileManage } from '../../snapshot/profile'

export const handlePollingRate = async (data: { Value: number }) => {
  const config = dataProfileManage().dataProfile
  if (data.Value > 0) {
    config.Mouse.Rate = data.Value
    dataProfileManage().save()
    await deviceManager.deviceDriver.syncConfig()
  }
  return config.Mouse.Rate
}
